module.exports = __webpack_public_path__ + "vue_assets/img/img_deios_roadmap.985c652a.webp";